module.exports = __webpack_public_path__ + "img/horizontal_3_2_8004.e856791c.png";